import $text from '@/services/i18n'
import $store from '@/store/index'
import Decimal from 'decimal.js'
import { getLanguage } from '@/util/language'

export default {
  applyChartOverrides (tvWidget, route = 'terminal') {
    const LINESTYLE_DASHED = 2
    let isThemeChanged = false
    const key =
      route === 'bots'
        ? 'isBotsThemeChanged'
        : route === 'booster'
          ? 'isBoosterThemeChanged'
          : route === 'terminal'
            ? 'isTerminalThemeChanged'
            : ''

    try {
      isThemeChanged = JSON.parse(localStorage.getItem(key))
    } catch (e) {}

    const isDark = $store.state.sys.theme === 'dark'

    if (key && !isThemeChanged && !isDark) {
      return
    }

    key && localStorage.setItem(key, false)
    let overrides = {
      'paneProperties.background': this.getCssVariable('--color-chart'),
      'paneProperties.backgroundType': 'solid',
      'scalesProperties.textColor': this.getCssVariable('--color-chart-text'),
      'scalesProperties.lineColor': this.getCssVariable('--color-chart-border'),
      'paneProperties.vertGridProperties.color': this.getCssVariable('--color-chart-border'),
      'paneProperties.vertGridProperties.style': LINESTYLE_DASHED,
      'paneProperties.horzGridProperties.color': this.getCssVariable('--color-chart-border'),
      'paneProperties.horzGridProperties.style': LINESTYLE_DASHED
    }
    if (isDark) {
      overrides = {
        ...overrides,
        'paneProperties.background': '#161b22',
        'paneProperties.vertGridProperties.color': 'rgba(0, 0, 0, 0)',
        'paneProperties.horzGridProperties.color': 'rgba(0, 0, 0, 0)'
      }
    }
    tvWidget.applyOverrides(overrides)
  },
  truncateWithStep (qty, step) {
    qty = new Decimal(qty)
    step = new Decimal(step)
    if (step.greaterThan(0)) {
      return qty
        .div(step)
        .toDP(0)
        .mul(step)
    } else {
      return qty
    }
  },
  getCssVariable (name) {
    return getComputedStyle(document.body)
      .getPropertyValue(name)
      .trim()
  },
  coinIcon (coin) {
    let i = coin.indexOf('-')
    if (i < 0) {
      i = coin.indexOf(' (')
    }
    if (i > 0) {
      return coin.substring(0, i)
    } else {
      return coin
    }
  },
  getTimezone () {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
    // console.log('timezone:', tz)
    return tz
  },
  getLanguage () {
    return getLanguage()
  },
  returnTextForErr (errText) {
    if (!errText) {
      return $text.tr('Неизвестная ошибка')
    }
    if (errText.message) {
      errText = errText.message
    } else if (typeof errText !== 'string') {
      errText = String(errText)
    }
    if (!errText) {
      return $text.tr('Неизвестная ошибка')
    }
    const lowerCaseErrText = errText.toLowerCase()
    if (lowerCaseErrText === 'timeout exceeded') {
      return $text.tr(
        'Биржа не отвечает. Проверьте ордер на бирже и попробуйте еще раз'
      )
    } else if (lowerCaseErrText === 'insufficient balance') {
      return $text.tr('Недостаточный баланс')
    } else if (lowerCaseErrText === 'filter failure: min_notional') {
      const url = $text.tr('https://doc.capico.app/ru/start/howtofix#oshibka-min-notional')
      return $text.tr('Свободный баланс меньше минимального ордера') +
        '. <a href="' + url + '" target="_blank">' + $text.tr('Подробнее') + '</a>'
    } else if (lowerCaseErrText.includes('filter failure: percent_price')) {
      const url = $text.tr('https://doc.capico.app/ru/start/howtofix#oshibka-percent-price')
      return $text.tr('Попытка установить ордер слишком далеко от текущей цены.') +
        ' <a href="' + url + '" target="_blank">' + $text.tr('Подробнее') + '</a>'
    } else if (lowerCaseErrText === 'error: network error' || lowerCaseErrText === 'network error') {
      const url = $text.tr('https://doc.capico.app/ru/start/howtofix#oshibka-network-error')
      return $text.tr('Проверьте настройки сетевого подключения.') +
        ' <a href="' + url + '" target="_blank">' + $text.tr('Подробнее') + '</a>'
    } else if (lowerCaseErrText.includes('order already executed')) {
      return $text.tr('Ордер уже исполнился.')
    } else if (lowerCaseErrText.includes('market slim qty = 0')) {
      return $text.tr('Количество равно нулю. Пожалуйста, проверьте свободный баланс активов')
    } else if (lowerCaseErrText.includes('exceeds the maximum leverage limit')) {
      return $text.tr('Слишком высокое плечо для текущего уровня риска')
    } else if (lowerCaseErrText.includes('this action disabled') || lowerCaseErrText === 'action disabled' || (lowerCaseErrText.includes('you must agree to the') && lowerCaseErrText.includes('trading terms'))) {
      return $text.tr('Действие недоступно для вашего аккаунта. Убедитесь, что биржа позволяет совершать подобные операции')
    } else if (lowerCaseErrText.includes('leverage reduction is not supported')) {
      return $text.tr('Нельзя изменить размер кредитного плеча при наличии открытой позиции на бирже')
    } else if (lowerCaseErrText === 'в настройках api ключа нужно включить') {
      const url = $text.tr('https://doc.capico.app/v/ru/ex/api')
      return $text.tr('В настройках API ключа нужно включить чтение и запись.') +
        ' <a href="' + url + '" target="_blank">' + $text.tr('Инструкция') + '</a>'
    } else if (lowerCaseErrText === 'hedge mode disabled') {
      const url = $text.tr('https://doc.capico.app/ru/start/howtofix#oshibka-hedge-mode-disabled')
      return $text.tr('Необходимо включить режим хеджирования.') +
        ' <a href="' + url + '" target="_blank">' + $text.tr('Инструкция') + '</a>'
    }
    return $text.tr(errText)
  },
  simulateRandomError () {
    const errors = [
      'Filter failure: PERCENT_PRICE',
      'Error: Network Error',
      'filter failure: min_notional',
      'order already executed. slim id: ia76',
      'market slim qty = 0. slim id = 7ciyk',
      'hedge mode disabled',
      'timeout exceeded',
      'insufficient balance',
      'Error: Request failed with status code 401',
      'request error: This action disabled is on this account.',
      'you are not authorized to execute this request',
      'pg: no rows in result set',
      'request error: Leverage reduction is not supported in Isolated Margin Mode with open positions.',
      'Not allowed with read-only permissions',
      'кол-во равно 0',
      'request error: Rest API trading is not enabled.',
      "can't convert 234. 59 to decimal",
      'request error: Leverage 50 is not valid',
      'Error: Request failed with status code 500',
      'order already executed. slim id: oiamt try again later',
      "invalid character '{' after top-level value",
      'Error: timeout of 0ms exceeded',
      'slimStep params are invalid',
      'system error',
      'exceeds the maximum leverage limit of the current risk limit level',
      'action disabled',
      'В настройках API ключа нужно включить',
      'bybit error: You must agree to the Crude Oil Trading Terms before trading this contract.',
      'bybit error: You must agree to the Trading Terms before trading this contract.'
    ]
    return errors[Math.floor(Math.random() * errors.length)]
  },
  startErrorSimulation (vm, interval = 5000) {
    const self = this
    return setInterval(function () {
      const errText = self.simulateRandomError()
      if (Math.random() > 0.5) {
        vm.$Notice.error({
          title: vm.$text.tr('Ошибка'),
          desc: self.returnTextForErr(errText),
          duration: 10
        })
      } else {
        vm.$Message.error({
          content: self.returnTextForErr(errText),
          duration: 10
        })
      }
    }, interval)
  },
  typeString (type) {
    switch (type) {
      case 'VIRTBUY':
      case 'SO':
      case 'TRADE':
      case 'COND':
      case 'APANIC':
      case 'PANIC':
        return ''
      case 'LIQUID':
        return $text.tr('ЛИКВИДАЦИЯ')
      default:
        return type
    }
  },
  exchId2sputnik (exchId) {
    if ($store.state.sys.tradeExchange.sptnk) {
      return $store.state.sys.tradeExchange.sptnk
    } else {
      return 'ge'
    }
  },
  exchId2sputnikOLD (exchId) {
    switch (exchId) {
      // case 'BIN':
      // case 'BIF':
      // case 'HUO':
      //   return 'tk'
      // case 'OKX':
      //   return 'hk'
      // case 'BYB':
      case 'BYF':
        return 'sg'
      case 'GET':
      case 'GEF':
        return 'get'
      // case 'EXM':
      //   return 'ge'
      default:
        return 'ge'
    }
  },
  onkeyDown (txt, e) {
    if (
      [46, 8, 9, 27, 13, 110].indexOf(e.keyCode) !== -1 ||
      // Allow: Ctrl+A
      (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
      // Allow: Ctrl+C
      (e.keyCode === 67 && (e.ctrlKey === true || e.metaKey === true)) ||
      // Allow: Ctrl+V
      (e.keyCode === 86 && (e.ctrlKey === true || e.metaKey === true)) ||
      // Allow: Ctrl+X
      (e.keyCode === 88 && (e.ctrlKey === true || e.metaKey === true)) ||
      // Allow: home, end, left, right
      (e.keyCode >= 35 && e.keyCode <= 39)
    ) {
      // let it happen, don't do anything
      return
    }

    if (e.keyCode === 190) {
      if (txt.includes('.')) {
        e.preventDefault()
        // } else if (e.target.value === 'ю') {
        //   e.target.value = '.'
      } else {
        return
      }
    }

    // Ensure that it is a number and stop the keypress
    if (
      (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
      (e.keyCode < 96 || e.keyCode > 105)
    ) {
      e.preventDefault()
    }
  }
}
